import { Injectable } from '@angular/core';
import { extractDeepPropertyByMapKey } from '../pipes/helpers';


@Injectable()
export class DataService {

    deepCopy<T>(object: T): T {
        return JSON.parse(JSON.stringify(object));
    }

    indexResults(array: Array<any>, properties?: string[]) {
        if (!properties) {
            properties = [];
            var exampleObject = array[0];
            if (exampleObject) {
                for (var p in exampleObject) {
                    if (exampleObject.hasOwnProperty(p)) {
                        properties.push(p);
                    }
                }
            }
        }

        for (let l = array.length, i = 0; i < l; i++) {
            var $index = [];
            var object = array[i];
            for (let k = properties.length, j = 0; j < k; j++) {
                $index.push(extractDeepPropertyByMapKey(object, properties[j]));
            }

            object.$index = $index.join('');
        }
    }

    indexObject(object: any, properties?: string[]) {
        this.indexResults([object], properties);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/data.service.ts